import { Trans } from '@lingui/react';
import cx from 'classnames';
import React from 'react';
import { usePricedCarsCounter } from '../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomerCounter = () => {
  const {
    pricedCarCount,
    isLoading
  } = usePricedCarsCounter();
  return /*#__PURE__*/_jsx("h1", {
    className: "carlead-creation-form__title customer-counter text-center mb-5",
    children: /*#__PURE__*/_jsx(Trans, {
      id: "carleadCreation.form.pricedCarCount.title",
      values: {
        pricedCarCount
      },
      components: {
        0: /*#__PURE__*/_jsx("strong", {}),
        1: /*#__PURE__*/_jsx("br", {}),
        2: /*#__PURE__*/_jsx("strong", {}),
        3: /*#__PURE__*/_jsx("span", {
          className: cx('priced-car-counter', {
            'priced-car-counter__loading': isLoading
          })
        })
      }
    })
  });
};
export default CustomerCounter;